import { combineReducers } from 'redux';
import { applyCombineReducersByIndex } from 'common/util/applyCombineReducersByKey';
import lodash from 'lodash';

import { hasSameValueCaseInsensitive } from 'common/util/hasSameValueCaseInsensitive';

import {
    INDEX_DOCUMENT_DESCRIPTOR_CHANGE_EDITOR_VALUE,
    INDEX_DOCUMENT_DESCRIPTOR_ADD_VALUE,
    INDEX_DOCUMENT_DESCRIPTOR_REMOVE_VALUE,
    INDEX_DOCUMENT_DESCRIPTOR_MARK_VALUE_VALIDITY,
    INDEX_DOCUMENT_DESCRIPTOR_SET_HIGHLIGHT_INDEX,
    INDEX_DOCUMENT_DESCRIPTOR_SET_MESSAGE,
    INDEX_DOCUMENT_DESCRIPTOR_VALUE_SET_EDITING_FLAG,
    INDEX_DOCUMENT_DESCRIPTOR_VALUE_COMMIT_CHANGE,
    INDEX_DOCUMENT_DESCRIPTOR_VALUE_SET_VALUE,
    INDEX_DOCUMENT_DESCRIPTOR_VALUE_MARK_VALUE_VALIDITY
} from 'indexDocuments/actions/descriptor';

function value(state = null, action) {
    if (action.type === INDEX_DOCUMENT_DESCRIPTOR_VALUE_COMMIT_CHANGE) {
        return action.payload.value;
    }
    return state;
}

function originalValue(state = null, action) {
    return state;
}

function valueEditableValue(state = '', action) {
    if (action.type === INDEX_DOCUMENT_DESCRIPTOR_VALUE_SET_VALUE) {
        return action.payload.value;
    }
    if (action.type === INDEX_DOCUMENT_DESCRIPTOR_VALUE_SET_EDITING_FLAG) {
        return action.payload.valueBeforeEdit;
    }
    return state;
}

function valueInvalidValue(state = false, action) {
    if (action.type === INDEX_DOCUMENT_DESCRIPTOR_VALUE_MARK_VALUE_VALIDITY) {
        return action.payload.value;
    }
    if (action.type === INDEX_DOCUMENT_DESCRIPTOR_VALUE_SET_EDITING_FLAG) {
        return false;
    }
    return state;
}

function editMode(state = false, action) {
    if (action.type === INDEX_DOCUMENT_DESCRIPTOR_VALUE_SET_EDITING_FLAG) {
        return action.payload.value;
    }
    if (action.type === INDEX_DOCUMENT_DESCRIPTOR_VALUE_COMMIT_CHANGE) {
        return false;
    }
    return state;
}

const valuesReducer = combineReducers({
    value,
    originalValue,
    editorValue: valueEditableValue,
    invalidValue: valueInvalidValue,
    editMode
});

function id(state = null, action) {
    return state;
}

function touched(state = false, action) {
    if ([
        INDEX_DOCUMENT_DESCRIPTOR_CHANGE_EDITOR_VALUE,
        INDEX_DOCUMENT_DESCRIPTOR_ADD_VALUE,
        INDEX_DOCUMENT_DESCRIPTOR_REMOVE_VALUE
    ].includes(action.type)) {
        return true;
    }
    return state;
}

function editorValue(state = '', action) {
    if (action.type === INDEX_DOCUMENT_DESCRIPTOR_CHANGE_EDITOR_VALUE) {
        return action.payload.value;
    }
    if (action.type === INDEX_DOCUMENT_DESCRIPTOR_ADD_VALUE) {
        return '';
    }
    return state;
}

function invalidValue(state = false, action) {
    if (action.type === INDEX_DOCUMENT_DESCRIPTOR_MARK_VALUE_VALIDITY) {
        return action.payload.value;
    }
    return state;
}

function highlightedIndex(state = -1, action) {
    if (action.type === INDEX_DOCUMENT_DESCRIPTOR_SET_HIGHLIGHT_INDEX) {
        return action.payload.index;
    }
    if (action.type === INDEX_DOCUMENT_DESCRIPTOR_REMOVE_VALUE) {
        const { index, remainingItems } = action.payload;
        return Math.min(index, remainingItems - 1);
    }
    return state;
}

function values(state = [], action) {
    if (action.type === INDEX_DOCUMENT_DESCRIPTOR_ADD_VALUE) {
        const { value: newValue } = action.payload;
        if (lodash.isNil(newValue) || (lodash.isEmpty(newValue) && lodash.isString(newValue))) {
            return state;
        }
        if (lodash.some(state, ({ value }) => hasSameValueCaseInsensitive(value, newValue))) {
            return state;
        }
        return [
            ...state,
            {
                value: newValue,
                originalValue: null,
                editorValue: newValue,
                invalidValue: false,
                editMode: false
            }
        ];
    }
    if (action.type === INDEX_DOCUMENT_DESCRIPTOR_REMOVE_VALUE) {
        const { index } = action.payload;
        if (index <= -1 || index >= state.length) {
            return state;
        }
        const values = [...state];
        values.splice(index, 1);
        return values;
    }
    return applyCombineReducersByIndex(valuesReducer, 'payload.valueIndex')(state, action);
}

function message(state = null, action) {
    if (action.type === INDEX_DOCUMENT_DESCRIPTOR_SET_MESSAGE) {
        return action.payload.message;
    }
    return state;
}

export const descriptor = combineReducers({
    id,
    touched,
    editorValue,
    invalidValue,
    highlightedIndex,
    values,
    message
});

